import React from 'react';
import classNames from 'classnames';

import ContentCarouselTripleDotted from 'rebook/apps/base/components/ContentCarouselTripleDotted';
import { catalogSlide, recomendationsSlide, statisticsSlide } from 'rebook/apps/landing/constants';
import Button from 'rebook/apps/base/components/Button';
import { URLS } from 'rebook/apps/base/constants';

import styles from './style.scss';


const CarouselItem = ({ title, description, imageClassName }) => (
  <div className={styles.sliderItem}>
    <div className={styles[imageClassName]} />
    <div className={styles.information}>
      <h2 className={styles.title}>{title}</h2>
      <big className={styles.description}>{description}</big>
    </div>
  </div>
);

const AllBooksBlock = () => (
  <div className="billetContainerNoOverflow">
    <div className={styles.slider}>
      <ContentCarouselTripleDotted>
        <div className="swiper-slide-point">
          <CarouselItem {...catalogSlide} />
        </div>
        <div className="swiper-slide-point">
          <CarouselItem {...recomendationsSlide} />
        </div>
        <div className="swiper-slide-point">
          <CarouselItem {...statisticsSlide} />
        </div>
      </ContentCarouselTripleDotted>
    </div>
    <div className={styles.features}>
      <CarouselItem {...catalogSlide} />
      <CarouselItem {...recomendationsSlide} />
      <CarouselItem {...statisticsSlide} />
    </div>
    <div className="billetContainerWrapper">
      <Button
        link={`${URLS.trialCard}?from=main_banner`}
        theme="advert"
        extraClassName={classNames(styles.allBookButton, 'jest-week-trial-link')}
        handeClick={() => { ga('send', 'event', 'Offer', 'PushButton', 'LandingBottom'); }}>
        <span>14 дней бесплатно</span>
      </Button>
    </div>
  </div>
);

export default AllBooksBlock;
